import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { RegisterComponent } from 'app/main/module/auth/register/register.component';
import {SharedModule} from '../../common/shared.module';
import { TranslateModule } from '@ngx-translate/core';

const routes = [
    {
        path     : 'register',
        component: RegisterComponent
    }
];

@NgModule({
    declarations: [
        RegisterComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        SharedModule,
        FuseSharedModule,
        TranslateModule
    ]
})
export class RegisterModule
{
}
